// extracted by mini-css-extract-plugin
export default {"products":"kx-z","card":"lx-z","oosMessaging":"mx-z"};